import styled from 'styled-components';
export const Container = styled.div `
  padding: 0px 12px;
  max-width: 620px;
  margin: auto;
`;
